const requerido = [
  { label: 'SI', id: true },
  { label: 'NO', id: false },
];

export default requerido;
